<template>
  <ul class="search__list" v-if="keywords.length > 0">
    <li
      class="search__item pnt"
      v-for="(item, index) in keywords"
      :key="index"
      @click="bindWord(item.keyword)"
    >
      <i class="i_search_bl"></i>
      <p v-html="colorWord(item.keyword)"></p>
    </li>
  </ul>
</template>
<script>
import { setKeyword } from '@common/lib/common/utils';

export default {
  name: 'component-search-list',
  description: '검색 페이지 > 검색 리스트',
  props: {
    keyword: String,
    keywords: Array,
  },
  methods: {
    bindWord(item) {
      this.$emit('bind-word', item);
    },
    colorWord(content) {
      return setKeyword(content, this.keyword);
    },
  },
};
</script>
<style scoped></style>
